import { NonProfitOrgInternalConfig, NonProfitOrgModelI, NonProfitOrgSchema, OrgStatus } from '@fieldday/fielddayportal-model'
import { Activity } from './Activity'
import { OrgUnit } from './OrgUnit'

export interface NPOWithId extends NonProfitOrgModelI {
  id: string
  status: OrgStatus
  extraFields?: NPOProfileFields
  charityNavEncompassScore?: number
  charityNavEncompassStarRating?: number
  city?: string
  state?: string
}

export interface NPO extends Partial<NonProfitOrgModelI> {
  id: string
  orgUnitId?: string  // if the nonprofit is managed by a team
  orgUnit?: Required<OrgUnit>
  flags?: string[]
  createdAt?: string
  status: OrgStatus
  extraFields?: NPOProfileFields
  memberCount?: number
  pastEventCount?: number
  futureEventCount?: number
  primaryRegion?: string
  linkToRegistrationDoc?: string
  internalConfig?: NonProfitOrgInternalConfig
}

export interface NPOProfileFields {
  mission?: string
  howVolunteersHelp?: string
  websiteURL?: string
  twitter?: string
  instagram?: string
  facebook?: string
}

export class NPOParser {
  npo: NPO | NPOWithId

  constructor(npo: NPO | NPOWithId) {
    this.npo = npo
  }

  parseNPO(): NPO {
    const profileFields: NPOProfileFields = {}
    // parse description into profile fields
    // if description is not valid json, assume it is just a string and assign it to 'mission' field
    try {
      Object.assign(profileFields, JSON.parse(this.npo?.description ?? ""))
    } catch (e) {
      profileFields.mission = this.npo?.description
    }

    return Object.assign({}, this.npo, { extraFields: profileFields }) as NPO
  }

  serializeNPO(): NPO | NPOWithId {
    const profileFields = this.npo.extraFields
    return Object.assign({}, this.npo, { description: JSON.stringify(profileFields) })
  }
}

export interface NPOWithActivities extends NPO {
  activities?: Activity[]
  hasCompleteProfile?: boolean
  extraFields?: NPOProfileFields
}

export { NonProfitOrgSchema }

export function updateNpo<NpoKey extends keyof NPO>(
  npo: NPO,
  property: NpoKey,
  value: NPO[NpoKey],
): void {
  npo[property] = value
}
